import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_KEY_TECHNOLOGY_REQUEST, fetchKeyTechnologiesFailure, fetchKeyTechnologiesSuccess } from "../actions/keyTechnologiesAction";
import { fetchKeyTechnologies } from "../../../services/accIqService";


// Worker Saga
function* fetchKeyTechnologiesSaga() {
  try {
    const payload = yield select(state=>state?.techLandscapeReducer?.payload);
    const data = yield call(fetchKeyTechnologies,payload);

    yield put(fetchKeyTechnologiesSuccess(data));
  } catch (error) {
    yield put(fetchKeyTechnologiesFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchKeyTechnologies() {
  yield takeLatest(FETCH_KEY_TECHNOLOGY_REQUEST, fetchKeyTechnologiesSaga);
}
